// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container--sUPsOvDf{background:rgba(184,187,205,0.2);border-radius:12px;border:1px solid rgba(255,255,255,0.3);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);padding:16px 26px}.container--sUPsOvDf:not(:first-child){margin-top:40px}.input--sHBtAfAH{margin-top:20px}.tips--z3ROgEOO{font-weight:500;color:#d48806;display:flex;align-items:center;gap:12px;margin-bottom:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container--sUPsOvDf`,
	"input": `input--sHBtAfAH`,
	"tips": `tips--z3ROgEOO`
};
export default ___CSS_LOADER_EXPORT___;
